<template>
    <div class="SwiperStyle">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" height="200px">
            <van-swipe-item v-for="(item , index) in BannerList" :key="index">
                <img :src="item.image" alt="" class="swipe_img" @click="Link(item.url)" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
export default {
    name: 'SwipeComponents',
    props: {
        BannerList: {
            type: Array,
            default: []
        },

    },
    methods: {
        Link(url) {
            this.$emit('Links', url);
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './index.scss';
</style>